import { getAppDir } from '../helper/Url';

class AutenticarService {    
    static logar(token) {
        localStorage.setItem('x-token', token);                    
        
        window.location.href = getAppDir();
    }    

    static getToken() {            
        return localStorage.getItem('x-token');
    }        

    static logout() {                     
        localStorage.removeItem('x-token');                   
        localStorage.removeItem('idEmpresa');
        localStorage.removeItem('cnpjEmpresa');

        window.location.href = getAppDir() + 'login';
    } 
    
    static setIdEmpresa(idEmpresa) {
        localStorage.setItem('idEmpresa', idEmpresa);                            
    }    

    static getIdEmpresa() {
        let idEmpresa = localStorage.getItem('idEmpresa');

        if(idEmpresa === undefined) {
            idEmpresa = 0;
        }

        if(idEmpresa === null) {
            idEmpresa = 0;
        }

        return idEmpresa;
    }  
    
    static getCnpjEmpresa() {
        let cnpjEmpresa = localStorage.getItem('cnpjEmpresa');

        if(cnpjEmpresa === undefined) {
            cnpjEmpresa = '';
        }

        if(cnpjEmpresa === null) {
            cnpjEmpresa = '';
        }

        return cnpjEmpresa;
    } 
    
    static setCnpjEmpresa(cnpjEmpresa) {
        localStorage.setItem('cnpjEmpresa', cnpjEmpresa);                            
    }
}

export default AutenticarService;